/**
 * Encodes a multipart body the way ASP.NET binds a form: a Blob is a file part, an array of Blobs repeats its key,
 * other arrays and nested objects use indexed and dotted keys (FormAnswers[0].Values[1]), a Date is ISO 8601, and a
 * null or undefined value is left out.
 */
export function toFormData(body: object): FormData {
  const form = new FormData();

  const append = (key: string, value: unknown): void => {
    if (value === undefined || value === null) {
      return;
    }

    if (value instanceof Blob) {
      form.append(key, value);
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => append(item instanceof Blob ? key : `${key}[${index}]`, item));
    } else if (value instanceof Date) {
      form.append(key, value.toISOString());
    } else if (typeof value === 'object') {
      Object.entries(value).forEach(([name, item]) => append(`${key}.${name}`, item));
    } else {
      form.append(key, String(value));
    }
  };

  Object.entries(body).forEach(([key, value]) => append(key, value));

  return form;
}
